import { ControllerFlowAPI } from 'yoshi-flow-editor-runtime/build/cjs/flow-api/ViewerScript';
import { MA_CHALLENGES_LIST_PAGE_TYPE } from '../editor/app-config';

export const isMA = (flowAPI: ControllerFlowAPI): boolean => {
  return flowAPI.widgetId === MA_CHALLENGES_LIST_PAGE_TYPE;
};
